import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import { PaginatedApiResponse, PaginationParams } from '@shared/api/pagination.types';
import { TenantDTO, CreateTenantDTO, UpdateTenantDTO } from '../dtos';

// Tenant Management API
export const tenantApi = {
  // Get all tenants (universities) with optional cursor-based pagination
  async getTenants(
    params?: PaginationParams
  ): Promise<ApiResponse<PaginatedApiResponse<TenantDTO>>> {
    const queryParams = new URLSearchParams();

    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    if (params?.cursor) {
      queryParams.append('cursor', params.cursor);
    }

    const url = queryParams.toString() ? `/tenants?${queryParams.toString()}` : '/tenants';
    const response = await apiClient.get<TenantDTO[]>(url);

    // Transform the response to match PaginatedApiResponse format
    // Backend returns { data: TenantDTO[], cursor?: string }
    return {
      status: response.status,
      message: response.message,
      data: {
        items: response.data || [],
        cursor: response.cursor,
      },
    };
  },

  // Get tenant by ID
  async getTenantById(tenantId: string): Promise<ApiResponse<TenantDTO>> {
    return apiClient.get<TenantDTO>(`/tenants/${tenantId}`);
  },

  // Create new tenant
  async createTenant(data: CreateTenantDTO): Promise<ApiResponse<TenantDTO>> {
    return apiClient.post<TenantDTO>('/tenants', data);
  },

  // Update existing tenant
  async updateTenant(tenantId: string, data: UpdateTenantDTO): Promise<ApiResponse<TenantDTO>> {
    return apiClient.put<TenantDTO>(`/tenants/${tenantId}`, data);
  },

  // Delete tenant
  async deleteTenant(tenantId: string): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/tenants/${tenantId}`);
  },
};

// Admin Management API - Only keeping the removal functionality
export const adminApi = {
  // Remove admin role (but keep user)
  async removeAdminRole(
    _userId: string,
    _tenantId: string,
    userRoleId: string
  ): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/user-roles/${userRoleId}`);
  },
};

// Export all APIs
export const manageApi = {
  tenant: tenantApi,
  admin: adminApi,
};
